<template>
  <div class="page-wrapper order-info">
    <navbar back fixed bg>
      <span slot="title">我的借款</span>
    </navbar>
    <div class="subbar-wrap" :class="{noTop: isWechat}">
      <div class="subbar-father">
        <router-link class="item" tag="li" :to="'/user/order/' + orderNo + '/detail?isFbs=' + isFbs + '&isFI='+isFI" replace :key="0">基本信息</router-link>
        <router-link class="item" tag="li" :to="'/user/order/' + orderNo + '/process?isFbs=' + isFbs + '&isFI='+isFI" replace :key="1">审批进程</router-link>
      </div>
    </div>
    <div class="page-content" :class="{contentTop: isWechat}">
      <keep-alive><router-view/></keep-alive>
    </div>
  </div>
</template>

<script>
import Navbar from 'components/navbar/navbar'
export default {
  components: {
    Navbar
  },
  data () {
    return {
      selectIndex: 0,
      isWechat: false,
      orderNo: '',
      isFI: 0,
      isFbs: 0
    }
  },
  mounted () {
    this.orderNo = this.$route.params.orderNo
    this.isFbs = Number(this.$route.query.isFbs) || 0
    this.isFI = Number(this.$route.query.isFI) || 0
  },
  created () {
    if (this.$device.isWechat) {
      this.isWechat = true
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../common/css/mixmin'
  .navbar
    height px2rem(88px)
    &.navbar-fixed
      & ~ .page-content
        top px2rem(176px)
        background-color rgba(255, 255, 255, 0.4)
  .subbar-wrap
    position relative
    left 0
    right 0
    bottom 0
    top px2rem(88px)
    .subbar-father
      margin 0
      padding 0
      position absolute
      top 0
      left 0
      right 0
      z-index 100
      height px2rem(88px)
      line-height px2rem(88px)
      box-shadow 0 0 10px rgba(39,84,130,.75)
      font-size 0
      background url("../../../static/images/bg-consultor.jpg") no-repeat top left
      background-size 100% auto
      .item
        width 50%
        display inline-block
        list-style none
        font-size px2rem(30px)
        color #CFDAE6
        text-align center
        position relative
        &.active
          color #fff
          font-weight bold
          &:after
            content ''
            position absolute
            width px2rem(40px)
            height px2rem(4px)
            background-color rgb(96, 201, 200)
            bottom px2rem(10px)
            left 50%
            transform translate(-50%)
  .noTop
    top 0
  .contentTop
    margin-top px2rem(88)
</style>



// WEBPACK FOOTER //
// order-info.vue?8f6ff3ba